import { useContext } from 'react';
import QuillContext from '../context/QuillContext';
import ReactQuill from 'react-quill';

export default function useQuill(): ReactQuill | null {
  return useContext(QuillContext).quillInstance;
}
